import { useEffect, useMemo } from 'preact/hooks'
import { browserStorage } from '../../audio/settings'
import type { Flow } from '../flow'
import { recordBest } from '../profile/bestTime'
import type { RoomInfo, Session } from '../session'
import { economy, timeRows } from './podiumData'
import { PodiumFrame } from './PodiumFrame'
import { ResultActions } from './ResultActions'
import { RewardPanel } from './RewardPanel'
import { rewardRows } from './rewardRows'

interface Props {
  session: Session
  flow: Flow
  room: RoomInfo | null
}

/**
 * The online results (PHASE3 T3.5): the race stage shows the podium (`RaceStage.showPodium`,
 * driven by the results mode), this screen the Match result panel from the own result row
 * (the server's `xp` / `coinsEarned`, T2.2), Phase 2's reward lines through the session's
 * `rewardLines` slot (D-053) and the buttons from `ResultActions`. A finish is kept as your best
 * time on the track when it beats it (the profile card's stat, T3.7).
 */
export function PodiumScreen({ session, flow, room }: Props) {
  const results = room?.results
  const me = room?.mySessionId ?? ''
  const own = results?.find((r) => r.sessionId === me) ?? null
  const reward = useMemo(() => (own ? rewardRows(own, economy()) : null), [own])
  const times = useMemo(() => timeRows(results ?? [], me), [results, me])
  const trackId = room?.trackId ?? ''
  useEffect(() => {
    if (own?.finished) recordBest(browserStorage(), trackId, own.finishMs)
  }, [own?.finished, own?.finishMs, trackId])
  // Duck-typed like every D-053 slot: a session without Phase 2's lines shows the rows only.
  const Slot = (session as Partial<Pick<Session, 'rewardLines'>>).rewardLines
  return (
    <PodiumFrame
      times={times}
      actions={<ResultActions session={session} flow={flow} room={room} />}
    >
      <RewardPanel reward={reward} {...(Slot ? { Slot } : {})} />
    </PodiumFrame>
  )
}
